import { AbilityBuilder, Ability } from '@casl/ability'

/**
 * candidatePages
 * agencyPages (consultant && manager && client)
 * sharedPages (like settings, help ...)
 * consultantPages
 * consulCandPages (consultant && candidate)
 *
 * @param {*} roles
 * @returns
 */
export const defineRulesFromRoles = roles => {
  const { can, build } = new AbilityBuilder(Ability)

  const has = r => roles?.includes(r)

  // Candidates only get their own area
  if (has('ROLE_CANDIDAT')) {
    can('read', 'candidatePages')
    can('read', 'consulCandPages')
    can('read', 'sharedPages')
  }

  // Consultants only get their own area
  if (has('ROLE_CONSULTANT')) {
    can('read', 'consultantPages')
    can('read', 'consulCandPages')
  }

  if (has('ROLE_MANAGER') || has('ROLE_CONSULTANT') || has('ROLE_CLIENT')) {
    can('read', 'agencyPages')
    can('read', 'sharedPages')
  }

  return build()
}
